import searchLocation from './searchLocation';

import './searchLocation.css';

export default searchLocation;
